'use client';

import { css } from '@flipster/styled-system/css';

import { HeroSection } from './section/1-hero';
import { PrivilegesSection } from './section/2-privileges';
import { FeeCalculatorSection } from './section/3-fee-calculator';
import { FeeTableSection } from './section/4-fee-table';
import { ApplyFormSection } from './section/5-apply-form';
import { ProofOfReservesSection } from './section/6-proof-of-reserves';
import { FaqSection } from './section/7-faq';
import { CtaSection } from './section/8-cta';

const containerStyle = css.raw({
  w: '100%',
  mx: 'auto',
  maxW: 'desktopMaxWidth',
  smallDesktop: {
    boxSizing: 'content-box',
  },
});

export const VipProgramPage = () => {
  return (
    <main className={css({ w: '100%' })}>
      <HeroSection />
      <PrivilegesSection css={containerStyle} />
      <FeeCalculatorSection css={containerStyle} />
      <FeeTableSection css={containerStyle} />
      <ApplyFormSection css={css.raw(containerStyle, { maxW: 600 })} />
      <div className={css({ pos: 'relative' })}>
        <ProofOfReservesSection css={containerStyle} />
      </div>
      <CtaSection css={containerStyle} />
      <FaqSection css={containerStyle} />
    </main>
  );
};
